import { gql } from '@lichtblick/apollo';

export const GET_BRANCH_FILTER_OPTIONS = gql`
  query GetBranches($page: PageInput) {
    getBranchOffices_V1(input: { page: $page, includeDeleted: true }) {
      totalItems
      error
      data {
        id
        isDeleted
        name
      }
    }
  }
`;
